module.exports = __webpack_public_path__ + "static/media/print.bf2386f6.jpg";